import { useEffect } from 'react';
import { ModalBody, ModalHeader } from 'components/Modals';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modals';
import { BROADCAST } from 'queries/query-keys';
import { useQuery } from '@tanstack/react-query';
import BroadcastService from 'services/BroadcastService';
import { ModalWrapper, StyledLoader } from './styles';
import { AutomationStatsList } from './AutomationStatsList';

export const AutomationStatisticsModal = ({ onHide, broadcast, ...props }) => {
  const { t } = useTranslation();

  const {
    data: automationStats,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [...BROADCAST.STATS, broadcast?.id],
    queryFn: () => BroadcastService.getAutomationBroadcastStats(broadcast?.id),
    retry: false,
    enabled: Boolean(broadcast?.id),
  });

  useEffect(() => {
    if (isError) {
      onHide();
    }
  }, [isError, onHide]);

  return (
    <Modal onHide={onHide} {...props} size="medium">
      <ModalHeader onClickClose={onHide}>
        {t('Agentic Workflow Broadcast Stats')}
      </ModalHeader>
      <ModalBody>
        <ModalWrapper>
          <StyledLoader loading={isLoading}>
            <AutomationStatsList
              automations={broadcast?.action?.automations}
              automationStats={automationStats}
            />
          </StyledLoader>
        </ModalWrapper>
      </ModalBody>
    </Modal>
  );
};
